import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/ibond-calculator',
  component: () => import('../../routes/IBondCalculator.svelte'),
  card: {
    id: 'ibond-calculator',
    title: 'I-Bond Calculator',
    description: 'Calculate I-Bond returns with inflation-linked interest and compound growth over time.',
    icon: 'savings',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/ibond-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'I-Bond Calculator – US Savings Bond Return & Interest Calculator',
    description: 'Free I-Bond calculator to estimate inflation-linked savings bond returns. Calculate composite rate earnings, penalty-free maturity dates, and year-by-year growth breakdown.',
  },
};

export default meta;